"use client"

import { Bell, Plus } from "lucide-react"
import { Button } from "@/components/ui/button"
import Link from "next/link";
import { useContext } from "react"
import { EventsContext } from "@/app/context/eventsContext"
//import { Input } from "@/components/ui/input"

interface HeaderProps {
  title: string
  subtitle?: string
  showNewEventButton?: boolean
}

export function Header({ title, subtitle, showNewEventButton = true }: HeaderProps) {
  const { events } = useContext(EventsContext)
  const unreadEventCount = events.filter((event) => event.status === "requested").length

  return (
    <header className="flex h-16 items-center justify-between px-6 border-b border-border bg-background">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground" style={{color: 'grey'}}>{subtitle}</p>}
      </div>

      <div className="flex items-center gap-4">
        {/* Notifications */}
        <Button asChild variant="ghost" size="icon" className="relative">
          <Link href="/events?status=requested" aria-label="View unread event requests">
            <Bell className="h-4 w-4" />
            {unreadEventCount > 0 && (
              <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-accent text-xs text-accent-foreground">
                {unreadEventCount}
              </span>
            )}
          </Link>
        </Button>

        {/* New Event Button */}
        {showNewEventButton && (
          <Link href="/event-request">
            <Button className="gap-2">
              <Plus className="h-4 w-4" />
              New Event
            </Button>
          </Link>
        )}
      </div>
    </header>
  )
}
